// extracted by mini-css-extract-plugin
module.exports = {"block":"JoinFaq_block__12LA9","title":"JoinFaq_title__h38jR"};